import { createSlice} from '@reduxjs/toolkit'

export const Cartslice = createSlice({
  name: 'cart',
  initialState: {
    value: 0,
    cartdata:[]
  },
  reducers: {
    addcart:(state , action)=>{
      
        var d=[...state.cartdata , action.payload];
        state.cartdata=d;
        console.log(action.payload);
    }
  }
})

export const { addcart} = Cartslice.actions

export default Cartslice.reducer